import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDetails = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.3417 9.15833V15C16.3417 15.4583 15.9667 15.8333 15.5083 15.8333H5.49166C5.03333 15.8333 4.65833 15.4583 4.65833 15V5C4.65833 4.54167 5.03333 4.16667 5.49166 4.16667H11.325C11.7833 4.16667 12.1583 3.79167 12.1583 3.33333C12.1583 2.875 11.7833 2.5 11.325 2.5H4.675C3.75833 2.5 3.00833 3.25 3.00833 4.16667V15.8333C3.00833 16.75 3.75833 17.5 4.675 17.5H16.325C17.2417 17.5 17.9917 16.7583 17.9917 15.8333V9.15833C17.9917 8.7 17.625 8.33333 17.1667 8.33333C16.7083 8.33333 16.3417 8.7 16.3417 9.15833ZM11.5333 8.95833L10.875 7.5C10.725 7.175 10.2667 7.175 10.1167 7.5L9.45833 8.95833L7.99166 9.61667C7.66666 9.76667 7.66666 10.225 7.99166 10.375L9.45 11.0333L10.1083 12.5C10.2583 12.825 10.7167 12.825 10.8667 12.5L11.525 11.0417L12.9917 10.3833C13.3167 10.2333 13.3167 9.775 12.9917 9.625L11.5333 8.95833ZM14.9417 3.95L15.4417 5.05L16.5417 5.55C16.7833 5.66667 16.7833 6.01667 16.5417 6.125L15.4417 6.625L14.9417 7.725C14.825 7.96667 14.475 7.96667 14.3667 7.725L13.8667 6.625L12.7667 6.125C12.525 6.00833 12.525 5.65833 12.7667 5.55L13.8667 5.05L14.3667 3.95C14.4833 3.70833 14.8333 3.70833 14.9417 3.95Z",
		fill: "currentColor"
	})
});
export default SvgDetails;
